import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OtherService {
  // state
  private isUserLogin = new BehaviorSubject(false);
  isUserLogin$ = this.isUserLogin.asObservable();

  // state
  private isSpecialistUserLogin = new BehaviorSubject<any>(null);
  isSpecialistUserLogin$ = this.isSpecialistUserLogin.asObservable();

  get specialistUser() {
    return this.isSpecialistUserLogin.value;
  }

  constructor() {
    // init state
    // extract the specialistInfo from localstorage and init its state
    this.initSpecialistUser();
  }

  changeUserLogin_Status(type: boolean) {
    this.isUserLogin.next(type);
  }

  changeSpecialistUserLogin_Status(type: any) {
    this.isSpecialistUserLogin.next(type);
  }

  logout() {
    sessionStorage.clear();
    localStorage.clear();
    this.changeUserLogin_Status(false);
    this.changeSpecialistUserLogin_Status(null);
  }

  initSpecialistUser() {
    const specialistInfo: string | null =
      localStorage.getItem('specialist-info');
    if (specialistInfo) {
      const initialValue = JSON.parse(specialistInfo);
      this.changeSpecialistUserLogin_Status(initialValue);
    }
  }

  getLocalStorage() {
    const userInfo = sessionStorage.getItem('info') || '{}';
    return JSON.parse(userInfo);
  }

  stringNumberToNumber(obj: any): any {
    const allowedWord = ['i', 'ti', 'f', 'd'];
    for (const key in obj) {
      if (typeof obj[key] === 'string') {
        const cleanedValue = obj[key].replace(/,/g, '');
        if (!isNaN(parseFloat(cleanedValue))) {
          for (const word of allowedWord) {
            if (key.startsWith(word)) {
              obj[key] = parseFloat(cleanedValue);
              break;
            }
          }
        }
      }
    }
    return obj;
  }

  isValidNationalId(code: string): boolean {
    if (!/^\d{10}$/.test(code)) {
      return false;
    }

    if (/^(\d)\1{9}$/.test(code)) {
      return false;
    }

    const digits = code.split('').map((d) => parseInt(d, 10));
    const checkDigit = digits[9];

    const sum = digits
      .slice(0, 9)
      .reduce((acc, curr, index) => acc + curr * (10 - index), 0);

    const remainder = sum % 11;
    const validCheck = remainder < 2 ? remainder : 11 - remainder;

    return checkDigit === validCheck;
  }
}
